export const convertToFloat = (val: any): number => parseFloat(val) || 0;
